import React, { useMemo } from 'react';
import { Typography, Chip, Stack } from '@mui/material';
import Table from '../common/Table';
import { getChipConfig } from 'utils/constants/chips';
import { excludeHiddenEmails } from 'utils/helpers/email.helper';

const OrganizationUsersTable = ({ users, onEditUser, globalFilter }) => {
    const filteredUsers = useMemo(() => excludeHiddenEmails(users), [users]);

    const columns = useMemo(
        () => [
            {
                Header: 'Member',
                accessor: row =>
                    `${row.first_name || ''} ${row.last_name || ''} ${
                        row.email || ''
                    }`.trim(),
                Cell: ({ row }) => (
                    <Stack spacing={0}>
                        <Typography variant="subtitle1">
                            {row.original.first_name} {row.original.last_name}
                        </Typography>
                        <Typography
                            variant="caption"
                            color="secondary"
                            sx={{ textTransform: 'none' }}
                        >
                            {row.original.email}
                        </Typography>
                    </Stack>
                )
            },
            {
                Header: 'Role',
                accessor: 'role',
                Cell: ({ row }) => (
                    <Chip {...getChipConfig(row.original.type, row.original.primary)} />
                )
            },
            {
                Header: 'Status',
                accessor: 'status',
                className: 'cell-center',
                Cell: () => <Chip size="small" color="success" label="Active" />
            }
        ],
        []
    );
    return (
        <Table
            columns={columns}
            data={filteredUsers}
            onRowClick={onEditUser}
            externalGlobalFilter={globalFilter}
        />
    );
};

export default OrganizationUsersTable;
